import { Box, BoxProps } from '@mantine/core';

export default function EmptyCell({
  children = null,
  ...props
}: {
  children?: React.ReactNode;
} & BoxProps) {
  return <Box {...props}>{children}</Box>;
}
